import React, { useState } from "react";
import FullCalendar, { formatDate } from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { INITIAL_EVENTS, createEventId } from "../components/event-utils";
import { Grid } from "@mui/material";
import esLocale from "@fullcalendar/core/locales/es";
import { SuccessAlert } from "../theme/index";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import {
  multiBookingAction,
  showMessageAction,
} from "../redux/reducers/MultiBooking";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import "moment/locale/es";
import DangerModal from "../components/DangerModal";
import SuccessModal from "../components/SuccessModal";
import { modalAction, modalDeleteAction } from "../redux/reducers/Modal";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { InputLabel, MenuItem } from "@mui/material";
import {
  PrimaryOutlinedButton,
  PrimaryLightInput,
  PrimaryLightSelect,
  SecondaryOutlinedButton,
} from "../theme/index";
import "../sass/styles.scss";
import FormControl from "@mui/material/FormControl";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import { EditReservation } from "../components/forms";
import { createReservationAction } from "../redux/reducers/Create";
import axios from "axios";
import { editReservationAction, openThisRoom } from "../redux/reducers/Edit";
import { saveReservationIdAction } from "../redux/reducers/Delete";
import { editRoomAction } from "../redux/reducers/Edit";
import {
  collection,
  getDocs,
  query,
  doc,
  getDoc,
  onSnapshot,
  where,
} from "firebase/firestore";
import { uploadFile } from "../config/firebase";
import db from "../config/firebase";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";

// toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: ".8rem",
  p: 4,
};

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.primary.light,
    color: "#000",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

const Booking = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showMessage, setShowMessage] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [reservationInfo, setReservationInfo] = React.useState({});
  const [editMode, setEditMode] = React.useState(false);
  const [validData, setValidData] = React.useState(false);
  const [currentEvents, setCurrentEvents] = React.useState([]);
  const [deleteReservationStatus, setDeleteReservationStatus] =
    React.useState(false);
  const [methodSelected, setMethodSelected] = React.useState("");

  // ** Form data
  const [reservationBy, setReservationBy] = React.useState("");
  const [searchClient, setSearchClient] = React.useState("");
  const [documentType, setDocumentType] = React.useState("");
  const [documentNumber, setDocumentNumber] = React.useState("");
  const [name, setName] = React.useState("");
  const [lName, setLName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [documentType2, setDocumentType2] = React.useState("");
  const [documentNumber2, setDocumentNumber2] = React.useState("");
  const [name2, setName2] = React.useState("");
  const [lName2, setLName2] = React.useState("");
  const [email2, setEmail2] = React.useState("");
  const [roomType, setRoomType] = React.useState("");
  const [reservationCheckin, setReservationCheckin] = React.useState("");
  const [reservationCheckout, setReservationCheckout] = React.useState("");
  const [elementToEdit, setElementToEdit] = React.useState("");
  const [currentRooms, setCurrentRooms] = React.useState([]);
  const [payDate, setPayDate] = React.useState("");
  const [payData, setPayData] = React.useState("");
  const [payReference, setPayReference] = React.useState("");
  const [imgToUpload, setImgToUpload] = React.useState({});

  // room
  const [roomNumber, setRoomNumber] = useState("");
  const [category, setCategory] = useState("");
  const [price, setPrice] = useState("");
  const [level, setLevel] = useState(0);
  const [status, setStatus] = useState("");
  const [details, setDetails] = useState("");

  const messageState = useSelector((state) => state.MultiBooking.showMessage);
  const modalState = useSelector((state) => state.Modal.modalState);
  const deleteModalState = useSelector((state) => state.Modal.deleteModalState);
  const reservationToCreate = useSelector((state) => state.Create.reservation);
  const reservationToDelete = useSelector(
    (state) => state.Delete.reservationId
  );
  const reservationStatusDelete = useSelector(
    (state) => state.Delete.reservationStatus
  );

  const notify = () =>
    toast.success("Hay una nueva reserva!", {
      position: "bottom-right",
      autoClose: false,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  const notifyCancelled = (checkIn) =>
    toast.error(`La reserva del ${checkIn} ha sido eliminada!`, {
      position: "bottom-right",
      autoClose: false,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  React.useEffect(() => {
    const getRooms = async () => {
      const q = query(collection(db, "room"));
      const querySnapshot = await getDocs(q);
      let roomArray = [];
      querySnapshot.forEach((doc) => {
        roomArray.push({ id: doc.id, ...doc.data() });
      });
      setCurrentRooms(roomArray);
    };

    getRooms();
  }, []);

  const [selectInfoState, setSelectInfoState] = React.useState({});

  const deleteReservation = async () => {
    setDeleteReservationStatus(true);
    dispatch(modalAction());
    dispatch(modalDeleteAction());
  };

  React.useEffect(() => {
    if (reservationStatusDelete == "SUCCESS") {
      const eventDeleted = currentEvents.filter(
        (item) => item.id !== reservationToDelete
      );
      setCurrentEvents(eventDeleted);
    }
  }, [reservationStatusDelete]);

  React.useEffect(() => {
    if (reservationToCreate.id) {
      console.log(reservationToCreate);
      let calendarApi = selectInfoState.view.calendar;

      calendarApi.unselect(); // clear date selection

      const eventInfo = calendarApi.addEvent({
        id: reservationToCreate.id,
        title: `${reservationToCreate.id} ${reservationToCreate.name} ${reservationToCreate.lastname}`,
        start: reservationToCreate.checkIn,
        end: reservationToCreate.checkOut,
        allDay: true,
      });

      console.log(calendarApi);

      setReservationInfo(eventInfo);
    }
  }, [reservationToCreate]);

  const editThisReservation = async () => {
    const reservationEdited = new FormData();
    const dataNames = [
      "checkIn",
      "checkOut",
      "documentType",
      "documentNumber",
      "name",
      "lastname",
      "email",
      "documentType2",
      "documentNumber2",
      "name2",
      "lastname2",
      "email2",
      "roomType",
    ];

    reservationEdited.append(dataNames[0], reservationCheckin);
    reservationEdited.append(dataNames[1], reservationCheckout);
    reservationEdited.append(dataNames[2], documentType);
    reservationEdited.append(dataNames[3], documentNumber);
    reservationEdited.append(dataNames[4], name);
    reservationEdited.append(dataNames[5], lName);
    reservationEdited.append(dataNames[6], email);
    reservationEdited.append(dataNames[7], documentType2);
    reservationEdited.append(dataNames[8], documentNumber2);
    reservationEdited.append(dataNames[9], name2);
    reservationEdited.append(dataNames[10], lName2);
    reservationEdited.append(dataNames[11], email2);
    reservationEdited.append(dataNames[12], roomType);
    reservationEdited.append("METHOD", "PUT");

    // comprobate current room with the edit room
    // get reservation (petition)
    const getReservationById = async (id) => {
      const docRef = doc(db, "reservation", `${id}`);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        /*if the reservation room is different to the edited reservation room change reservations room status 
            (the first is open and the edited is close)*/
        if (docSnap.data().roomType !== roomType) {
          // ocupar habitacion
          // change room status
          const changeRoomStatus = (response, status) => {
            const roomEdited = new FormData();
            const dataNames = [
              "id",
              "roomNumber",
              "category",
              "price",
              "level",
              "status",
              "details",
            ];

            roomEdited.append(dataNames[0], response.id);
            roomEdited.append(dataNames[1], response.roomNumber);
            roomEdited.append(dataNames[2], response.category);
            roomEdited.append(dataNames[3], response.price);
            roomEdited.append(dataNames[4], response.level);
            roomEdited.append(dataNames[5], status);
            roomEdited.append(dataNames[6], response.details);
            roomEdited.append("METHOD", "PUT");

            dispatch(editRoomAction(roomEdited, dataNames, response.id));
          };

          // get room info
          const getRoomInfo = async (id, status) => {
            let response;
            const docRef = doc(db, "room", `${id}`);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
              response = docSnap.data();
            } else {
              console.log("No such document!");
            }

            changeRoomStatus(response, status);
          };

          getRoomInfo(docSnap.data().roomType, "open");
          getRoomInfo(roomType, "close");
        }
      } else {
        console.log("No such document!");
      }
    };

    getReservationById(elementToEdit);

    dispatch(
      editReservationAction(reservationEdited, dataNames, elementToEdit)
    );

    // change data
    const eventsEdited = currentEvents.map((item) => {
      return item.id == elementToEdit
        ? { ...item, title: `${name} ${lName} (${item.documentNumber})` }
        : item;
    });

    setCurrentEvents(eventsEdited);

    dispatch(modalAction());
  };

  const saveReservation = async () => {
    const newReservation = new FormData();
    const dataNames = [
      "checkIn",
      "checkOut",
      "documentType",
      "documentNumber",
      "name",
      "lastname",
      "email",
      "documentType2",
      "documentNumber2",
      "name2",
      "lastname2",
      "email2",
      "payDate",
      "pay_data",
      "pay_method",
      "referenceData",
      "roomType",
    ];

    newReservation.append(dataNames[0], reservationCheckin);
    newReservation.append(dataNames[1], reservationCheckout);
    newReservation.append(dataNames[2], documentType);
    newReservation.append(dataNames[3], documentNumber);
    newReservation.append(dataNames[4], name);
    newReservation.append(dataNames[5], lName);
    newReservation.append(dataNames[6], email);
    newReservation.append(dataNames[7], documentType2);
    newReservation.append(dataNames[8], documentNumber2);
    newReservation.append(dataNames[9], name2);
    newReservation.append(dataNames[10], lName2);
    newReservation.append(dataNames[11], email2);
    newReservation.append(dataNames[12], payDate !== "" ? payDate : "");
    newReservation.append(dataNames[13], payData !== "" ? payData : "");
    newReservation.append(
      dataNames[14],
      methodSelected == "transferencia" ? "transferencia" : "estadia"
    );
    newReservation.append(
      dataNames[15],
      payReference !== "" ? payReference : ""
    );
    newReservation.append(dataNames[16], roomType);
    newReservation.append("METHOD", "POST");

    if (methodSelected == "transferencia") {
      uploadFile(imgToUpload);
    }

    dispatch(createReservationAction(newReservation, dataNames));

    // ocupar habitacion
    // change room status
    const changeRoomStatus = (response) => {
      const roomEdited = new FormData();
      const dataNames = [
        "id",
        "roomNumber",
        "category",
        "price",
        "level",
        "status",
        "details",
      ];

      roomEdited.append(dataNames[0], response.roomType);
      roomEdited.append(dataNames[1], response.roomNumber);
      roomEdited.append(dataNames[2], response.category);
      roomEdited.append(dataNames[3], response.price);
      roomEdited.append(dataNames[4], response.level);
      roomEdited.append(dataNames[5], "close");
      roomEdited.append(dataNames[6], response.details);
      roomEdited.append("METHOD", "PUT");

      dispatch(editRoomAction(roomEdited, dataNames, roomType));
    };

    // get room info
    const getRoomInfo = async () => {
      let response;

      const docRef = doc(db, "room", `${roomType}`);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        response = docSnap.data();
      } else {
        console.log("No such document!");
      }

      changeRoomStatus(response);
    };
    getRoomInfo();

    dispatch(modalAction());
  };

  const mappingEvents = (data) => {
    let eventsList = [];

    data.map((item) => {
      eventsList.push({
        id: item.id,
        start: item.checkIn,
        end: item.checkOut,
        title: `${item.name} ${item.lastname} (${item.documentNumber})`,
      });
    });

    setCurrentEvents(eventsList);
  };

  React.useEffect(() => {
    let eventsList = [];

    const getCurrentEvents = async () => {
      const q = query(collection(db, "reservation"));

      let arraySize = localStorage.getItem("reservationQuantity")
        ? JSON.parse(localStorage.getItem("reservationQuantity"))
        : 0;

      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        let reservationArray = [];
        mappingEvents([]);

        if (arraySize !== 0 && arraySize < querySnapshot.size) {
          // show notify
          for (let index = 0; index < querySnapshot.size - arraySize; index++) {
            notify();
          }
        }

        arraySize = querySnapshot.size;
        localStorage.setItem(
          "reservationQuantity",
          JSON.stringify(querySnapshot.size)
        );
        querySnapshot.forEach((doc) => {
          reservationArray.push({ id: doc.id, ...doc.data() });
        });
        mappingEvents(reservationArray);
      });
    };

    const getCancelledEvents = async () => {
      const q = query(collection(db, "cancelledReservation"));

      let arraySize = localStorage.getItem("cancelledReservation")
        ? JSON.parse(localStorage.getItem("cancelledReservation"))
        : 0;

      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        let reservationArray = [];

        if (arraySize !== 0 && arraySize < querySnapshot.size) {
          // show notify
          for (let index = 0; index < querySnapshot.size - arraySize; index++) {
            notifyCancelled(querySnapshot.docs[index + 1].data().checkIn);
          }
        }

        arraySize = querySnapshot.size;
        localStorage.setItem(
          "cancelledReservation",
          JSON.stringify(querySnapshot.size)
        );
        querySnapshot.forEach((doc) => {
          reservationArray.push({ id: doc.id, ...doc.data() });
        });
      });
    };

    getCurrentEvents();
    getCancelledEvents();
    setReservationInfo(currentEvents);
  }, []);

  React.useEffect(() => {
    setShowModal(modalState);
  }, [modalState]);

  React.useEffect(() => {
    setShowDeleteModal(deleteModalState);
  }, [deleteModalState]);

  React.useEffect(() => {
    setShowMessage(messageState);

    if (messageState) {
      setTimeout(() => {
        dispatch(showMessageAction());
        setShowMessage(false);
      }, 3000);
    }
  }, []);

  const [state, setState] = React.useState({
    weekendsVisible: true,
    currentEvents: [],
  });

  const handleWeekendsToggle = () => {
    setState({
      weekendsVisible: !this.state.weekendsVisible,
    });
  };

  const checkDate = (checkIn, checkOut) => {
    const currentDate = moment().format("YYYY-MM-DD");
    return !moment(currentDate).isAfter(checkIn, "day") &&
      !moment(currentDate).isAfter(checkOut, "day")
      ? false
      : true;
  };

  const getReservationById = async (id) => {
    const docRef = doc(db, "reservation", `${id}`);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      if (docSnap.data().AlejandrosReservation) {
        setReservationBy(docSnap.data().AlejandrosReservation);
      } else {
        setReservationBy(null);
      }
      setDocumentType(docSnap.data().documentType);
      setDocumentNumber(docSnap.data().documentNumber);
      setName(docSnap.data().name);
      setLName(docSnap.data().lastname);
      setEmail(docSnap.data().email);
      setDocumentType2(docSnap.data().documentType2);
      setDocumentNumber2(docSnap.data().documentNumber2);
      setName2(docSnap.data().name2);
      setLName2(docSnap.data().lastname2);
      setEmail2(docSnap.data().email2);
      setRoomType(docSnap.data().roomType);
      setMethodSelected(docSnap.data().pay_method);
      setPayData(docSnap.data().pay_data);
      setReservationCheckin(docSnap.data().checkIn);
      setReservationCheckout(docSnap.data().checkOut);
    } else {
      console.log("No such document!");
    }
  };

  const reservationDetails = (selectInfo) => {
    setEditMode(true);
    setDeleteReservationStatus(false);
    // valid date
    setReservationCheckin(selectInfo.event.startStr);
    setReservationCheckout(selectInfo.event.endStr);
    setElementToEdit(selectInfo.event._def.publicId);

    dispatch(saveReservationIdAction(selectInfo.event._def.publicId));
    getReservationById(selectInfo.event._def.publicId);

    dispatch(modalAction());

    // if (checkDate(selectInfo.event.startStr, selectInfo.event.endStr)) {
    //   dispatch(modalDeleteAction());
    // } else {
    //   // valid date
    //   setReservationCheckin(selectInfo.event.startStr);
    //   setReservationCheckout(selectInfo.event.endStr);
    //   setElementToEdit(selectInfo.event._def.publicId);

    //   dispatch(saveReservationIdAction(selectInfo.event._def.publicId));
    //   getReservationById(selectInfo.event._def.publicId);

    //   dispatch(modalAction());
    // }
  };

  const changeReservation = (selectInfo) => {
    if (checkDate(selectInfo.event.startStr, selectInfo.event.endStr)) {
      setValidData(false);
    } else {
      setValidData(true);
    }
    dispatch(modalAction());
  };

  const cleanData = () => {
    setDocumentType("");
    setDocumentNumber("");
    setName("");
    setLName("");
    setEmail("");
    setDocumentType2("");
    setDocumentNumber2("");
    setName2("");
    setLName2("");
    setEmail2("");
    setRoomType("");
    setReservationCheckin("");
    setReservationCheckout("");
  };

  const handleDateSelect = (selectInfo) => {
    setEditMode(false);
    cleanData();

    setSelectInfoState(selectInfo);
    if (checkDate(selectInfo.startStr, selectInfo.endStr)) {
      dispatch(modalDeleteAction());
    } else {
      let calendarApi = selectInfo.view.calendar;

      calendarApi.unselect(); // clear date selection

      // const eventInfo = calendarApi.addEvent({
      //   id: createEventId(),
      //   title,
      //   start: selectInfo.startStr,
      //   end: selectInfo.endStr,
      //   allDay: selectInfo.allDay
      // })

      //setReservationInfo(eventInfo);

      setReservationCheckin(selectInfo.startStr);
      setReservationCheckout(selectInfo.endStr);
      dispatch(modalAction());
    }
  };

  const deleteEvent = (clickInfo) => {
    dispatch(modalAction());
    console.log(clickInfo);
    //clickInfo.remove()
  };

  const editEvent = (clickInfo) => {
    //clickInfo.remove()
    dispatch(modalAction());
  };

  const handleEvents = (events) => {
    setState({
      currentEvents: events,
    });
  };

  const payMethodHandler = (e) => {
    let payMethod = e.target.value;
    setMethodSelected(payMethod);

    if (payMethod == "estadia" || payMethod == "") {
      imgButton("hide");
      return "estadia";
    } else {
      imgButton("show");
      return "transferencia";
    }
  };

  const renderEventContent = (eventInfo) => {
    return (
      <>
        <b>{eventInfo.timeText}</b>
        <HtmlTooltip
          placement="top"
          title={
            <>
              <b>{"Cliente"}</b>
              <Typography color="inherit">Nombre: Alejandro Perez</Typography>
              <Typography color="inherit">Habitacion: Matrimonial</Typography>
              <Typography color="inherit">Nº Hab: 002</Typography>
            </>
          }
        >
          <i>{eventInfo.event.title}</i>
        </HtmlTooltip>
      </>
    );
  };

  const createReservations = (events) => {
    const eventsInfo = state.currentEvents.map((item) => {
      return {
        start: item.startStr,
        end: item.endStr,
      };
    });

    dispatch(multiBookingAction(eventsInfo));
    navigate("/createmultibooking");
  };

  const imgButton = (type = "hide") => {
    if (type == "show") {
      const addImgContainer =
        document.getElementsByClassName("file-upload-btn")[0];
      addImgContainer.style.display = "inline-flex";
    } else {
      const addImgContainer =
        document.getElementsByClassName("file-upload-btn")[0];
      document.querySelector(".file-upload-image").style.display = "none";
      document.querySelector(".remove-image").style.display = "none";
      document.querySelector(".file-upload-content").style.display = "none";
      document.querySelector(".referenceData").style.display = "none";
      document.querySelector(".pay_date").style.display = "none";
      addImgContainer.style.display = "none";
    }
  };

  const removeUpload = (e) => {
    document.querySelector(".file-upload-image").style.display = "none";
    document.querySelector(".remove-image").style.display = "none";
    document.querySelector(".file-upload-content").style.display = "none";

    const fileInput = document.querySelectorAll(".file-upload-input input")[0];
    // $(".file-upload-input").replaceWith($(".file-upload-input").clone());
    document.querySelector(".file-upload-content").display = "none";
    document.querySelector(".image-upload-wrap").display = "inline-flex";
  };

  const readUrl = (input) => {
    let inputTarget = input.target;
    if (inputTarget.files && inputTarget.files[0]) {
      var reader = new FileReader();

      reader.onload = function (e) {
        document.querySelector(".image-upload-wrap").style.display = "none";

        document.querySelector(".file-upload-image").src = e.target.result;
        setImgToUpload(inputTarget.files[0]);
        setPayData(e.target.result);
        document.querySelector(".file-upload-content").style.display =
          "inline-block";

        document.querySelector(".image-title").innerHTML =
          inputTarget.files[0].name;

        document.querySelector(".file-upload-image").style.display = "block";
        document.querySelector(".remove-image").style.display = "block";
        document.querySelector(".file-upload-content").style.display = "block";
        document.querySelector(".referenceData").style.display = "block";
        document.querySelector(".pay_date").style.display = "block";
      };

      reader.readAsDataURL(inputTarget.files[0]);
    } else {
      removeUpload();
    }
  };

  const addImg = (e) => {
    const fileInput = document.querySelectorAll(".file-upload-input input")[0];
    fileInput.click();
  };

  return (
    <>
      <Grid container className="demo-app" sx={{ justifyContent: "center" }}>
        <ToastContainer />
        {showModal === true && editMode === false && validData === false && (
          <Modal open={true} onClose={() => deleteEvent(reservationInfo)}>
            <Grid container sx={style}>
              <Grid item xs={12} textAlign="end">
                <IconButton
                  align="end"
                  style={{
                    backgroundColor: "#EEE",
                    width: "1rem",
                    height: "1rem",
                  }}
                  onClick={() => deleteEvent(reservationInfo)}
                >
                  <CloseIcon
                    style={{ color: "#000", width: ".8rem" }}
                    align="end"
                  />
                </IconButton>
              </Grid>
              <>
                <Grid item xs={6} sx={{ mt: 4 }}>
                  <h5 style={{ margin: "0" }}>Crear reserva</h5>
                  <p style={{ margin: "0" }}>
                    {reservationCheckin} - {reservationCheckout}
                  </p>
                </Grid>
                <Grid item xs={6} sx={{ mt: 4 }}>
                  <PrimaryLightInput
                    label="Buscar cliente"
                    fullWidth
                    value={searchClient}
                    onChange={(e) => setSearchClient(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sx={{ mt: 6 }}>
                  <p>Huésped</p>
                </Grid>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Tipo de documento
                        </InputLabel>
                        <PrimaryLightSelect
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Tipo de documento"
                          value={documentType}
                          onChange={(e) => setDocumentType(e.target.value)}
                        >
                          <MenuItem value="passport">Pasaporte</MenuItem>
                          <MenuItem value="v">V-</MenuItem>
                          <MenuItem value="e">E-</MenuItem>
                          {/* <MenuItem value='identification'>Nº de identificación</MenuItem> */}
                        </PrimaryLightSelect>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
                      <PrimaryLightInput
                        label="Nº de documento"
                        fullWidth
                        value={documentNumber}
                        onChange={(e) => setDocumentNumber(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
                      <PrimaryLightInput
                        label="Nombre"
                        fullWidth
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
                      <PrimaryLightInput
                        label="Apellido"
                        fullWidth
                        value={lName}
                        onChange={(e) => setLName(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6} className="pr-2">
                      <PrimaryLightInput
                        label="E-mail / Teléfono"
                        fullWidth
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                  <p>Acompañante</p>
                </Grid>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Tipo de documento
                        </InputLabel>
                        <PrimaryLightSelect
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Tipo de documento"
                          value={documentType2}
                          onChange={(e) => setDocumentType2(e.target.value)}
                        >
                          <MenuItem value="passport">Pasaporte</MenuItem>
                          <MenuItem value="v">V-</MenuItem>
                          <MenuItem value="e">E-</MenuItem>
                          {/* <MenuItem value='identification'>Nº de identificación</MenuItem> */}
                        </PrimaryLightSelect>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
                      <PrimaryLightInput
                        label="Nº de documento"
                        fullWidth
                        value={documentNumber2}
                        onChange={(e) => setDocumentNumber2(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
                      <PrimaryLightInput
                        label="Nombre"
                        fullWidth
                        value={name2}
                        onChange={(e) => setName2(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
                      <PrimaryLightInput
                        label="Apellido"
                        fullWidth
                        value={lName2}
                        onChange={(e) => setLName2(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6} className="pr-2">
                      <PrimaryLightInput
                        label="E-mail (opcional)"
                        fullWidth
                        value={email2}
                        onChange={(e) => setEmail2(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                  <p>Habitación</p>
                </Grid>
                <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select--two-label">
                      Tipo de Habitación
                    </InputLabel>
                    <PrimaryLightSelect
                      labelId="demo-simple-select-two-label"
                      id="demo-simple-select-two"
                      value={roomType}
                      onChange={(e) => setRoomType(e.target.value)}
                    >
                      {currentRooms.length > 0 &&
                        currentRooms.map((room) => {
                          if (room.status == "open") {
                            return (
                              <MenuItem value={room.id}>
                                {room.roomNumber} - {room.category}
                              </MenuItem>
                            );
                          }
                        })}
                    </PrimaryLightSelect>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                  <p>Método de pago</p>
                </Grid>
                <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
                  <FormControl fullWidth>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="estadia"
                      name="radio-buttons-group"
                      onChange={payMethodHandler}
                    >
                      <FormControlLabel
                        value="estadia"
                        control={
                          <Radio
                            sx={{
                              background: "#69D0A3 !important",
                              marginRight: ".5rem",
                            }}
                          />
                        }
                        label=" Pagar al llegar"
                        sx={{ marginBottom: "1rem" }}
                      />
                      <FormControlLabel
                        value="transferencia"
                        control={
                          <Radio
                            sx={{
                              background: "#69D0A3 !important",
                              marginRight: ".5rem",
                            }}
                          />
                        }
                        label=" Nº Pago Móvil / Transferencia"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Grid item class="col-12 col-md-12" id="file_upload">
                    <Grid item class="file-upload mt-2 mb-3">
                      <PrimaryOutlinedButton
                        className="file-upload-btn"
                        sx={{ display: "none" }}
                        onClick={addImg}
                      >
                        Agregar imagen
                      </PrimaryOutlinedButton>

                      <Grid item class="image-upload-wrap">
                        <PrimaryLightInput
                          className="file-upload-input"
                          type="file"
                          onChange={readUrl}
                          accept="image/*"
                          sx={{ display: "none" }}
                        />
                      </Grid>
                      <Grid
                        item
                        class="file-upload-content"
                        sx={{ display: "none" }}
                      >
                        <img
                          class="file-upload-image"
                          src="#"
                          style={{ width: "100%", display: "none" }}
                          alt="your image"
                        />
                        <Grid item class="image-title-wrap">
                          <SecondaryOutlinedButton
                            className="remove-image"
                            sx={{ display: "none" }}
                            onClick={removeUpload}
                          >
                            Remover
                            <span class="image-title">
                              &nbsp;Uploaded Image
                            </span>
                          </SecondaryOutlinedButton>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item class="row">
                      <Grid item class="col-12 col-md-6">
                        <PrimaryLightInput
                          type="text"
                          label="Nº de referencia"
                          fullWidth
                          value={payReference}
                          onChange={(e) => setPayReference(e.target.value)}
                          id="referenceData"
                          className="referenceData"
                          sx={{ display: "none", margin: "1rem 0" }}
                          minlength="6"
                        />
                      </Grid>
                      <Grid item class="col-12 col-md-6">
                        <PrimaryLightInput
                          type="text"
                          label="Fecha"
                          fullWidth
                          value={payDate}
                          onChange={(e) => setPayDate(e.target.value)}
                          minlength="6"
                          sx={{ display: "none", margin: "0 0 1rem" }}
                          id="pay_date"
                          className="pay_date"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sx={{ mt: 2 }}
                  textAlign="end"
                  className="pr-2"
                >
                  <PrimaryOutlinedButton onClick={() => saveReservation()}>
                    Crear reserva
                  </PrimaryOutlinedButton>
                </Grid>
              </>
            </Grid>
          </Modal>
        )}
        {showModal === true && editMode === true && validData === false && (
          <Modal open={true} onClose={() => dispatch(modalAction())}>
            <Grid container sx={style}>
              <Grid item xs={12} textAlign="end">
                <IconButton
                  align="end"
                  style={{
                    backgroundColor: "#EEE",
                    width: "1rem",
                    height: "1rem",
                  }}
                  onClick={() => editEvent(reservationInfo)}
                >
                  <CloseIcon
                    style={{ color: "#000", width: ".8rem" }}
                    align="end"
                  />
                </IconButton>
              </Grid>
              <Grid item xs={6} sx={{ mt: 4 }}>
                <h5 style={{ margin: "0" }}>Editar reserva</h5>
                <p style={{ margin: "0" }}>
                  {moment(reservationCheckin).format("L")} -{" "}
                  {moment(reservationCheckout).format("L")}
                </p>
              </Grid>
              <Grid item xs={6} sx={{ mt: 4 }}>
                <PrimaryLightInput
                  label="Buscar cliente"
                  fullWidth
                  value={searchClient}
                  onChange={(e) => setSearchClient(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sx={{ mt: 6 }}>
                {reservationBy ? <p>Reserva hecha por: <b>Alejandro</b></p> : null}
                <p>Huésped</p>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Tipo de documento
                      </InputLabel>
                      <PrimaryLightSelect
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Tipo de documento"
                        value={documentType}
                        onChange={(e) => setDocumentType(e.target.value)}
                      >
                        <MenuItem value="passport">Pasaporte</MenuItem>
                        <MenuItem value="v">V-</MenuItem>
                        <MenuItem value="e">E-</MenuItem>
                        {/* <MenuItem value='identification'>Nº de identificación</MenuItem> */}
                      </PrimaryLightSelect>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
                    <PrimaryLightInput
                      label="Nº de documento"
                      fullWidth
                      value={documentNumber}
                      onChange={(e) => setDocumentNumber(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
                    <PrimaryLightInput
                      label="Nombre"
                      fullWidth
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
                    <PrimaryLightInput
                      label="Apellido"
                      fullWidth
                      value={lName}
                      onChange={(e) => setLName(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={6} className="pr-2">
                    <PrimaryLightInput
                      label="E-mail / Teléfono"
                      fullWidth
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sx={{ mt: 2 }}>
                <p>Acompañante</p>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Tipo de documento
                      </InputLabel>
                      <PrimaryLightSelect
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Tipo de documento"
                        value={documentType2}
                        onChange={(e) => setDocumentType2(e.target.value)}
                      >
                        <MenuItem value="passport">Pasaporte</MenuItem>
                        <MenuItem value="v">V-</MenuItem>
                        <MenuItem value="e">E-</MenuItem>
                        {/* <MenuItem value='identification'>Nº de identificación</MenuItem> */}
                      </PrimaryLightSelect>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
                    <PrimaryLightInput
                      label="Nº de documento"
                      fullWidth
                      value={documentNumber2}
                      onChange={(e) => setDocumentNumber2(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
                    <PrimaryLightInput
                      label="Nombre"
                      fullWidth
                      value={name2}
                      onChange={(e) => setName2(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
                    <PrimaryLightInput
                      label="Apellido"
                      fullWidth
                      value={lName2}
                      onChange={(e) => setLName2(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={6} className="pr-2">
                    <PrimaryLightInput
                      label="E-mail (opcional)"
                      fullWidth
                      value={email2}
                      onChange={(e) => setEmail2(e.target.value)}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sx={{ mt: 2 }}>
                <p>Habitación</p>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ mb: 2, textTransform: "capitalize" }}
                className="pr-2"
              >
                <b>Seleccionada: {roomType}</b>
              </Grid>
              <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Tipo de Habitación
                  </InputLabel>
                  <PrimaryLightSelect
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={roomType}
                    onChange={(e) => setRoomType(e.target.value)}
                  >
                    {currentRooms.length > 0 &&
                      currentRooms.map((room) => {
                        if (room.status == "open" || room.id == roomType) {
                          return (
                            <MenuItem value={room.id}>
                              {room.roomNumber} - {room.category}
                            </MenuItem>
                          );
                        }
                      })}
                  </PrimaryLightSelect>
                </FormControl>
              </Grid>
              <Grid item xs={12} sx={{ mt: 2 }}>
                <p>Método de pago</p>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ mb: 2, textTransform: "capitalize" }}
                className="pr-2"
              >
                <b>Seleccionado: {methodSelected}</b>
              </Grid>
              {methodSelected === "transferencia" ? (
                <Grid
                  item
                  xs={12}
                  sx={{ mb: 2, textTransform: "capitalize" }}
                  className="pr-2"
                >
                  <img
                    style={{ width: "100%" }}
                    src={payData}
                    alt="Imagen de la transferencia"
                  />
                </Grid>
              ) : null}
              <Grid item xs={12} sx={{ mt: 2 }} className="pr-2">
                <Grid container>
                  <Grid item xs="6">
                    <SecondaryOutlinedButton
                      onClick={() => deleteReservation()}
                    >
                      Eliminar reserva
                    </SecondaryOutlinedButton>
                  </Grid>
                  <Grid item xs="6" textAlign="end">
                    <PrimaryOutlinedButton
                      onClick={() => editThisReservation()}
                    >
                      Editar reserva
                    </PrimaryOutlinedButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Modal>
        )}
        {showModal === true && validData === true && (
          <SuccessModal view="validDate" />
        )}
        {showDeleteModal && !deleteReservationStatus && (
          <DangerModal view="invalidDate" />
        )}
        {showDeleteModal && deleteReservationStatus && (
          <DangerModal view="deleteReservation" />
        )}
        <Grid
          container
          className="demo-app-sidebar"
          sx={{ justifyContent: "center", mb: 4 }}
        >
          <Grid item xs={10} className="demo-app-sidebar-section">
            <h2 style={{ fontFamily: "Roboto-Thin", marginBottom: "1rem" }}>
              Reservar
            </h2>
            {showMessage && (
              <SuccessAlert
                sx={{ mb: 4, textAlign: "center", justifyContent: "center" }}
              >
                Felicidades! Reservas creadas exitosamente.
              </SuccessAlert>
            )}
          </Grid>
        </Grid>

        <Grid item xs={10} className="demo-app-main">
          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            headerToolbar={{
              left: "prev,next today",
              center: "title",
              //right: 'dayGridMonth,timeGridWeek,timeGridDay'
              right: "dayGridMonth",
            }}
            initialView="dayGridMonth"
            locale={esLocale}
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={true}
            weekends={true}
            initialEvents={INITIAL_EVENTS} // alternatively, use the `events` setting to fetch from a feed
            select={handleDateSelect}
            eventClick={reservationDetails}
            eventChange={changeReservation}
            events={currentEvents}
            eventsSet={handleEvents} // called after events are initialized/added/changed/removed
          />

          {/* <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            headerToolbar={{
              left: 'prev,next today',
              center: 'title',
              right: 'dayGridMonth,timeGridWeek,timeGridDay'
            }}
            events={[
              { title: 'event 1', date: '2022-11-21' },
              { title: 'event 2', date: '2022-11-23' }
            ]}
            initialView='dayGridMonth'
            locale={esLocale}
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={true}
            weekends={state.weekendsVisible}
            initialEvents={INITIAL_EVENTS} // alternatively, use the `events` setting to fetch from a feed
            select={handleDateSelect}
            eventClick={reservationDetails}
            eventsSet={handleEvents} // called after events are initialized/added/changed/removed
            eventChange={ changeReservation }
            
          /> */}
        </Grid>
      </Grid>
    </>
  );
};

export default Booking;
